import { render, staticRenderFns } from "./ChangeOfStatusReadonly.vue?vue&type=template&id=b735a426&scoped=true"
import script from "./ChangeOfStatusReadonly.vue?vue&type=script&lang=js"
export * from "./ChangeOfStatusReadonly.vue?vue&type=script&lang=js"
import style0 from "./ChangeOfStatusReadonly.vue?vue&type=style&index=0&id=b735a426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b735a426",
  null
  
)

export default component.exports